import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';


export default class TitleCard extends React.Component {

  render(){

    return (
        <Grid item xs={12} md={12} lg={12}>
          <Box>
            <Typography variant="h5" component="span" style={{display: 'inline-block'}}>
              {this.props.data.name}
            </Typography>
            <Typography variant="h6" component="span" style={{display: 'inline-block', color:'red'}}>
              &nbsp;&nbsp;{ (typeof this.props.data.paused !== 'undefined')?"(Paused)":""}
            </Typography>
          </Box>
        </Grid>
    );
  }
}
